<template>
    <dados-edital v-model="licitacao"></dados-edital>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import DadosEdital from '../commons/DadosEdital'

    export default {
        name: 'LicitacaoFornecedorEdital',
        components: {DadosEdital},
        computed: {
            ...mapState(['licitacao'])
        },
        async mounted() {
            await this.buscarAnexos()
        },
        methods: {
            async buscarAnexos() {
                this.setMensagemLoading('Atualizando listagem de anexos...')
                await this.buscarAnexosLicitacao(this.$route.params.id)
            },
            ...mapActions([actionTypes.BUSCAR_ANEXOS_LICITACAO])
        }
    }
</script>